var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaiora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141 33",
    fill: "currentColor",
    role: "img",
    "aria-label": "Maiora",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.4125 4.83339L13.5855 21.3868L6.75849 4.83339H4.69988L0 28.167H3.6709L6.58968 13.1754L12.5565 28.167H14.6145L20.581 13.1754L23.5001 28.167H27.171L22.4711 4.83339H20.4125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7513 4.83339L31.631 28.1667H35.3019L37.6926 22.4335H47.8683L50.2594 28.1667H53.93L43.8096 4.83339H41.7513ZM38.9715 19.3666L42.7806 10.2335L46.5895 19.3666H38.9715Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5754 4.83339H58.836V28.1667H62.5754V4.83339Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.689 4.5C73.862 4.5 68.3387 9.86669 68.3387 16.5C68.3387 23.1333 73.862 28.5 80.689 28.5C87.516 28.5 93.0394 23.1333 93.0394 16.5C93.0394 9.86669 87.516 4.5 80.689 4.5ZM80.689 24.7667C75.9892 24.7667 72.1809 21.0665 72.1809 16.5C72.1809 11.9335 75.9892 8.23329 80.689 8.23329C85.3889 8.23329 89.1971 11.9335 89.1971 16.5C89.1971 21.0665 85.3889 24.7667 80.689 24.7667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.821 4.83339L118.701 28.167H122.372L124.762 22.4335H134.938L137.329 28.167H141L130.88 4.83339H128.821ZM129.85 10.2335L133.659 19.3669H126.041L129.85 10.2335Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.943 11.0668C112.011 7.69999 109.713 4.83339 104.635 4.83339H98.803V28.1667H102.542V17.3002H104.635C104.703 17.3002 104.77 17.2992 104.837 17.2983L110.536 28.1667H114.241L108.229 16.6397C110.758 15.5633 111.893 13.3238 111.943 11.0668ZM102.542 7.9668H104.944C106.865 7.9668 108.203 9.10001 108.203 11.0668C108.203 13.0336 106.865 14.1668 104.944 14.1668H102.542V7.9668Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiora);
export default __webpack_public_path__ + "static/media/maiora.7edfb632baa18c37f9b633ea6ba7d8a9.svg";
export { ForwardRef as ReactComponent };